<!------ MORE OPTIONS TAB SECTION - DESKTOP ------->
@if (!universalService.hideTopMenu) {
  <div class="more-options-tab-inline-main mb-2" [ngClass]="[universalService?.emptyTabViewRequiresMenu && !universalService?.viewIsTabOriented ? 'empty-tabbed-view-selection' : '']">
    <!-- Icons -->
    <div class="left-icon-set" id="more-options-tab-inline-main">
      @if (!router.url.includes('/memory') && this.universalService.selectedNodes.length >= 1) {
        <div class="selection-cont">
          <span class="mr-1" id="topMenuCounter">{{this.universalService.selectedNodes.length}} Selected</span><i class="NeueClose" (click)="decideAction('closeMenu',$event)"></i>
        </div>
      }
      @for (item of universalService.topMenuOptions; track item) {
        <span>
          <span class="{{item.iconName}} mr-1" title="{{item.title}}"
          data-toggle="modal" (click)="decideAction(item.onClick, $event)" [ngClass]="[item.title == 'Share link' && this.universalService.isAllowPublicShare == false ? 'hideOption' : '']"></span>
        </span>
      }
      @if (universalService.openMoreOptions) {
        <div class="dropdown-menu" [ngClass]="router.url.includes('/memory') ? 'memoryMenu' : '' ">
          @for (item of universalService.moreOptionsOnTopMenu; track item) {
            <span id="{{item.onClick}}" class="dropdown-item pointer" (click)="decideAction(item.onClick,$event)" [ngClass]="item.title == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''">
              @if (item.iconName != '') {
                <span class="{{item.iconName}}"></span>
              }
              @if (item.imageUrl  && item.iconName == '') {
                <img class="img-fluid" src="{{item.imageUrl}}">
              }
              <span>{{item.menuItem}}</span> <span class="{{item.moreOptionsIcon}} moreOptionsIcon"></span>
            </span>
          }
        </div>
      }
      @if (universalService.openMoreOptions && universalService.openMoreOptionsContextMenu) {
        <div class="dropdown-menu expandMoreOption">
          @for (item of universalService.contextMenuMoreOptions; track item) {
            <span class="dropdown-item pointer" title="{{item.title}}" (click)="decideAction(item.onClick,$event)" [ngClass]="item.title == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''">
              @if (item.iconName != '') {
                <span class="{{item.iconName}}"></span>
              }
              @if (item.imageUrl  && item.iconName == '') {
                <img class="img-fluid" src="{{item.imageUrl}}">
              }
              <span>{{item.menuItem}}</span>
            </span>
          }
        </div>
      }
    </div>
    @if (((universalService.selectedTab == 'teamfolders' && router.url.includes('/teamfolders/')) || universalService.selectedTab == 'TeamsFolderOperations') && !universalService.showTopMenu && universalService.currentTeamFolder) {
      <div class="sort-wrapper team-header-options">
        <ul>
          @if (universalService?.currentTeamFolder?.tfType == 'R') {
            <li><span class="Neuelock_line"></span></li>
          }
          <li><span class="team-count"><em class="NeueShared"></em>{{universalService.currentTeamFolder?.tfMemberCount}}</span></li>
          <li><span class="team-count">{{universalService.currentTeamFolder?.roleName}}</span></li>
          <li>@if (universalService.currentTab == 'teamfolders') {
            <span class="NeueMore_Options" (click)="fetchTeamFolderOperationOptionsBasedonRole()"></span>
          }</li>
        </ul>
        @if (openMoreOptions) {
          <div class="dropdown-menu team-folder-operations-dropdown">
            @for (item of moreOptions; track item) {
              <span class="dropdown-item pointer" title="{{item.title}}" (click)="decideAction(item.onClick,$event)" [ngClass]="item.title == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''">
                <span class="{{item.iconName}}" ></span>
                <span>{{item.menuItem}}</span>
              </span>
            }
          </div>
        }
      </div>
    }
    <!-- <p>{{universalService.showSortButtons}}//{{universalService.selectedTab }}</p> -->
    @if ((this.router.url.includes('/allfiles') || this.router.url.includes('/photos') || this.router.url.includes('/videos')) && !this.router.url.includes('/search') && universalService.showSortButtons) {
      <div class="sort-wrapper" [ngStyle]="{'float' : this.router.url.includes('/teamfolders/') ? 'right':'' }" (mouseleave)="universalService.showPeopleSortMenu = false" >
        <div class="sort-list-main">
          @if (!this.universalService.listView) { 
            @if (universalService.selectedNodes.length == 0) {
              <span class="sort-prop-name" (click)="changeSort()">
                 <em class="name">{{getCurrentSortType()}} </em> <!--universalService.sharePublicSortPropName  -->
                  <em id="trafficIcon" class="sort-order {{universalService.sortIcon}}"></em>
              </span>
            }
            <span class="shared-files-view">
              <button class="NeueExpand" [disabled]="this.universalService.showTopMenu || this.universalService.emptyFolder || universalService.emptyShared" title="Sorted by {{universalService.getCurrentSortType(universalService.sharePublicSort)}}" (click)="showShareSortingDropDown()"></button>
              @if (universalService.showShareSortingOptions && universalService.selectedNodes.length == 0) {
                <div class="dropdown-menu">
                  @if (this.router.url.includes('/allfiles')) {
                  <span class="dropdown-item pointer sort-by-name" (click)="openPublicSort('objectName')">
                    Name @if (universalService.sharePublicSort.indexOf('objectName') > -1) {
                      <span class="NeueCheck"></span>
                    }
                  </span>
                  }
                  <span class="dropdown-item pointer sort-by-created-date" (click)="openPublicSort('fileCreatedDate')">
                    Created @if (universalService.sharePublicSort.indexOf('fileCreatedDate') > -1) {
                      <span class="NeueCheck"></span>
                    }
                  </span>
                  <!-- @if(!this.router.url.includes('/allfiles')) { -->
                    <span class="dropdown-item pointer sort-by-uploaded-date" (click)="openPublicSort('createdDate')">
                      Uploaded @if (universalService.sharePublicSort.indexOf('createdDate') > -1) {
                        <span class="NeueCheck"></span>
                      }
                    </span>
                  <!-- } -->
                </div>
              }
            </span>
          }


          @if (!this.universalService.listView && ( this.universalService.currentTab == 'allfiles')) {
            <span>
              <a rel="noopener noreferrer">
                <button class="NeueListView ml-3"
                  [disabled]="this.universalService.showTopMenu || this.universalService.emptyFolder || universalService.emptyFav" title="Switch to List View"
                (click)="this.openView()"></button>
              </a>
            </span>
          }

          @if (this.universalService.listView && !shareAccessService.isSharedFilesView) {
            <span>
              <a rel="noopener noreferrer">
                <button class="NeueGridView"
                [disabled]="this.universalService.showTopMenu || this.universalService.emptyFolder || universalService.emptyFav" title="Switch to Grid View" (click)="this.openView()"></button>
              </a>
            </span>
          }
        </div>
      </div>
    }
   
    @if (!this.router.url.includes('/allfiles') && ( this.router.url.includes('search/photos') || !this.router.url.includes('/photos')) && ( this.router.url.includes('search/videos') || !this.router.url.includes('/videos'))  && !this.router.url.includes('/dataexport')  && !universalService.isUserOnSharedLinkByMe && !universalService.emptyTab && universalService.showSortButtons  && universalService.selectedTab != 'Albums' && universalService.selectedTab != 'Album Details') {
      <div class="sort-wrapper" [ngStyle]="{'float' : this.router.url.includes('/teamfolders/') ? 'right':'' }" [ngClass]="this.router.url.includes('/places') ? 'places-sort-wrapper' : '' ">
        <div class="sort-list-main">
          <!-- @if (!this.universalService.listView && universalService.nameSort!=null) {
            <span>
              @if (this.universalService.nameSort) {
                <button class="NeueSort" [disabled]="this.universalService.showTopMenu || this.universalService.emptyFolder" title="Sort by date"
                (click)="openPublicSort('fileCreatedDate')"></button>
              }
              @if (!this.universalService.nameSort) {
                <button class="NeueA-Z"
                  [disabled]="this.universalService.showTopMenu || this.universalService.emptyFolder" title="Sort by Name"
                (click)="openPublicSort('objectName')"></button>
              }
            </span>
          } -->
          @if ((!this.universalService.listView &&  !this.router.url.includes('/favorites/') && !this.router.url.includes('filter/recents') && !this.router.url.includes('people/face') && !this.router.url.includes('search') && !this.router.url.includes('places'))) { 
            @if (universalService.selectedNodes.length == 0) {
              <span class="sort-prop-name" (click)="changeSort()">
                <em class="name"> {{getCurrentSortType()}}</em><!--getSharePublicSortPropName-->
                @if (universalService.activeRepo == 'main') { 
                <em id="trafficIcon" class="sort-order {{universalService.sortIcon}}"></em> <!-- NeueDownTraffic NeueUpTraffic-->
                } 
              </span>
            }
            <span class="shared-files-view">
              <button class="NeueExpand" [disabled]="this.universalService.showTopMenu || this.universalService.emptyFolder || universalService.emptyShared" title="Sorted by {{universalService.getCurrentSortType(universalService.sharePublicSort)}}" (click)="showShareSortingDropDown()"></button>
              @if (universalService.showShareSortingOptions && universalService.selectedNodes.length == 0) {
                <div class="dropdown-menu">
                 
                  <span class="dropdown-item pointer sort-by-name" (click)="openPublicSort('objectName')">
                    Name @if (universalService.sharePublicSort.indexOf('objectName') > -1) {
                      <span class="NeueCheck"></span>
                    }
                  </span>
                  @if (this.router.url.includes('/privatefolder') && !this.router.url.includes('places/place')) {
                    <span class="dropdown-item pointer sort-by-created-date" (click)="openPublicSort('fileCreatedDate')">
                      Created @if (universalService.sharePublicSort.indexOf('fileCreatedDate') > -1) {
                        <span class="NeueCheck"></span>
                      }
                    </span>
                  }@else{
                    @if(!this.router.url.includes('places/place')){
                      <span class="dropdown-item pointer sort-by-created-date" (click)="openPublicSort('fileCreatedDate')">
                        Created @if (universalService.sharePublicSort.indexOf('fileCreatedDate') > -1) {
                          <span class="NeueCheck"></span>
                        }
                      </span>
                    }
                  }
                </div>
              }
            </span>
          }
          @if (!this.universalService.listView && ( this.universalService.currentTab == 'allfiles' || this.universalService.currentTab == 'Favorites' || this.router.url.includes('/teamfolders/')  || this.router.url.includes('/privatefolder') || this.universalService.currentTab == 'Search Results')) {
            <span>
              <a rel="noopener noreferrer">
                <button class="NeueListView ml-3"
                  [disabled]="this.universalService.showTopMenu || this.universalService.emptyFolder || universalService.emptyFav" title="Switch to List View"
                (click)="this.openView()"></button>
              </a>
            </span>
          }
          @if (this.universalService.listView && !shareAccessService.isSharedFilesView && !this.router.url.includes('/audio') && !this.router.url.includes('/docs')) {
            <span>
              <a rel="noopener noreferrer">
                <button class="NeueGridView"
                [disabled]="this.universalService.showTopMenu || this.universalService.emptyFolder || universalService.emptyFav" title="Switch to Grid View" (click)="this.openView()"></button>
              </a>
            </span>
          }
          <!-- @if (this.universalService.listView && shareAccessService.isSharedFilesView && !shareAccessService.showUnivShareLinkFiles && !universalService.openFolderContent) {
            <span class="shared-files-view">
              <button class="NeueSort" [disabled]="this.universalService.showTopMenu || this.universalService.emptyFolder || universalService.emptyShared" title="Sort by date" (click)="showShareSortingDropDown()"></button>
              @if (universalService.showShareSortingOptions && universalService.selectedNodes.length == 0) {
                <div class="dropdown-menu">
                  <span class="dropdown-item pointer" (click)="changeSortType('shareCreated')">Share Date @if (shareAccessService.sort == 'shareCreated') {
                    <span class="NeueCheck"></span>
                  }</span>
                  <span class="dropdown-item pointer" (click)="changeSortType('lastModified')">Last Modified @if (shareAccessService.sort == 'lastModified') {
                    <span class="NeueCheck"></span>
                  }</span>
                </div>
              }
            </span> 
          } -->
          @if (!universalService.listView && (universalService.currentTab == 'Person Details' || universalService.currentTab == 'Places')) {
            @if(universalService.currentTab == 'Person Details' ){
              <span class="people-files-view">
                <button class="NeueSort" [disabled]="universalService.showTopMenu || universalService.emptyTab" title="Sort images" (click)="showPeopleSorting()" style="font-size: 22px; color: #141414; background: transparent; cursor: pointer;"></button>
                @if (universalService.showPeopleSortMenu && universalService.selectedNodes.length == 0) {
                  <div class="dropdown-menu" >
                    <span class="dropdown-item pointer sort-by-date-latest" (click)="getSortedFaces('%2DfileCreatedDate','Date Latest')">Date Latest @if (sortType == '%2DfileCreatedDate') {
                      <span class="NeueCheck" ></span>
                    }</span>
                    <span class="dropdown-item pointer sort-by-date-oldest" (click)="getSortedFaces('%2BfileCreatedDate','Date Oldest')">Date Oldest @if (sortType == '%2BfileCreatedDate') {
                      <span class="NeueCheck"></span>
                    }</span>
                    <span class="dropdown-item pointer sort-by-least-faces" (click)="getSortedFaces('%2BfaceCount','Least Faces')">Least Faces @if (sortType == '%2BfaceCount') {
                      <span class="NeueCheck"></span>
                    }</span>
                    <span class="dropdown-item pointer sort-by-most-faces" (click)="getSortedFaces('%2DfaceCount','Most Faces')">Most Faces @if (sortType == '%2DfaceCount') {
                      <span class="NeueCheck"></span>
                    }</span>
                  </div>
                }
              </span>
            }
            @if(universalService.currentTab == 'Places' ){
              <span class="people-files-view">
                <button class="NeueSort" [disabled]="universalService.showTopMenu || universalService.emptyTab" title="Sort images" (click)="showPlaceSorting()" style="font-size: 22px; color: #141414; background: transparent; cursor: pointer;"></button>
                @if (universalService.showPeopleSortMenu && universalService.selectedNodes.length == 0) {
                  <div class="dropdown-menu" >
                    <span class="dropdown-item pointer sort-by-date-latest" (click)="getSortedPlaces('+placeName','Name A-z')">Name A-z @if (sortType == '+placeName') {
                      <span class="NeueCheck" ></span>
                    }</span>
                    <span class="dropdown-item pointer sort-by-date-oldest" (click)="getSortedPlaces('-placeName','Name Z-a')">Name Z-a @if (sortType == '-placeName') {
                      <span class="NeueCheck"></span>
                    }</span>
                      <span class="dropdown-item pointer sort-by-least-faces" (click)="getSortedPlaces('+objectCount','Least Objects')">Least Objects @if (sortType == '+objectCount') {
                        <span class="NeueCheck"></span>
                      }</span>
                      <span class="dropdown-item pointer sort-by-most-faces" (click)="getSortedPlaces('-objectCount','Most Objects')">Most Objects @if (sortType == '-objectCount') {
                        <span class="NeueCheck"></span>
                      }</span>
                  </div>
                }
              </span>
            }
          }
        </div>
      </div>
    }
  </div>
}
<!------ MORE OPTIONS TAB SECTION - DESKTOP ------->



<!-- MODAL - 1 : MORE OPTIONS Header Modal - MOBILE -->
@if (this.universalService.isMobileTopMoreOptionMenu) {
  <div class="modal fade" id="more-options-modal" (click)="outsideClick($event)" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': this.universalService.isMobileTopMoreOptionMenu ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content animated fixed-bottom">
        @if (universalService.activeRepo == 'share') {
          <div class="modal-header">
            <div class="share-modal-head-inner">
              <h1>Share Via</h1>
              <div class="float-left mr-3 options-head">
                <span (click)="shareOnWhatsApp()" class="Neuewhatsapp"></span>
                <em>Whatsapp</em>
              </div>
              <div class="float-left ml-3 options-head">
                <span class="NeueMore_Options" (click)="shareMoreOptions()"></span>
                <em class="pt-1">More Apps</em>
              </div>
            </div>
          </div>
        }
        <div class="modal-body">
          @if (!universalService.uploadButtonClicked && !universalService.isMobileShareOptionClicked && !this.universalService.moreOptionsOnMobileClicked) {
            <div class="more-options-menu">
              <ul>
                @if(!router.url.includes("/contacts")){
                <!---->
                @if (!(this.router.url.includes('/allfiles') || this.router.url.includes('/photos') || this.router.url.includes('/videos') || this.router.url.includes('/audio') || this.router.url.includes('/docs')) && universalService.nameSort!=null && universalService.nameSort &&
                  !universalService.fetchAllRecentFiles && !shareAccessService.isSharedFilesView && !this.router.url.includes('/?c')) {
                  <li (click)="openPublicSort('fileCreatedDate')">
                    <span class="NeueSort mr-3" title="Sort by date"></span>Sort By Date</li>
                  }
                  <!-- -->
                  @if (!(this.router.url.includes('/allfiles') || this.router.url.includes('/photos') || this.router.url.includes('/videos') || this.router.url.includes('/audio') || this.router.url.includes('/docs')) && universalService.nameSort!=null && !this.universalService.nameSort &&
                    !universalService.fetchAllRecentFiles && !shareAccessService.isSharedFilesView && !this.router.url.includes('/digilocker') && !this.router.url.includes('/jpai')  && !this.router.url.includes('/?c')) {
                    <li (click)="openPublicSort('objectName')">
                      <span class="NeueA-Z mr-3" title="Sort by Name"></span>Sort By Name</li>
                    }


                  @if (this.router.url.includes('/allfiles') || this.router.url.includes('/photos') || this.router.url.includes('/videos') || this.router.url.includes('/audio') || this.router.url.includes('/docs') &&
                  !universalService.fetchAllRecentFiles && !shareAccessService.isSharedFilesView && !this.router.url.includes('/jpai') && !this.router.url.includes('/?c')) {
                    <li (click)="openPublicSort('objectName')">
                      <span class="NeueSort mr-3" title="Sort by name"></span>Sort By Name
                      @if (universalService.sharePublicSort.indexOf('objectName') > -1) {
                        <span class="NeueCheck"></span>
                      }
                    </li>
                    <li (click)="openPublicSort('fileCreatedDate')">
                      <span class="NeueSort mr-3" title="Sort by created date"></span>Sort By Created
                      @if (universalService.sharePublicSort.indexOf('fileCreatedDate') > -1) {
                        <span class="NeueCheck"></span>
                      }
                    </li>
                    @if(!this.router.url.includes('/allfiles')) {
                      <li (click)="openPublicSort('createdDate')">
                        <span class="NeueSort mr-3" title="Sort by uploaded date"></span>Sort By Uploaded
                        @if (universalService.sharePublicSort.indexOf('createdDate') > -1) {
                          <span class="NeueCheck"></span>
                        }
                      </li>
                    }
                  }



                    @if (router.url.includes('/shared/') && !universalService.isUserOnSharedLinkByMe && !universalService.openFolderContent) {
                      <div>
                        @if (shareAccessService.sortType == 'shareCreated') {
                          <li (click)="changeSortType('lastModified')">
                            <span class="NeueSort mr-3" title="Sort by date"></span>Last Modified
                          </li>
                        }
                        @if (shareAccessService.sortType == 'lastModified') {
                          <li (click)="changeSortType('shareCreated')">
                            <span class="NeueSort mr-3" title="Sort by Name"></span>Share Date
                          </li>
                        }
                      </div>
                    }
                    @if (universalService.isUserOnSharedLinkByMe && !universalService.openFolderContent) {
                      <div>
                        @if (shareAccessService.sharedLinkSortType == 'sname') {
                          <li (click)="changeSharedLinkSortType('cd')">
                            <span class="NeueSort mr-3" title="Sort by Name"></span>Date Created
                          </li>
                        }
                        @if (shareAccessService.sharedLinkSortType == 'cd') {
                          <li (click)="changeSharedLinkSortType('sname')">
                            <span class="NeueSort mr-3" title="Sort by Date Created"></span>Name
                          </li>
                        }
                      </div>
                    }
                    @if (universalService.currentTab == 'Person Details') {
                      <div class="people-tab-sort-menu">
                        <li (click)="getSortedFaces('%2DfileCreatedDate','Date Latest')" class="sort-by-date-latest">
                          <span class="NeueSort mr-3" title="Sort by latest date"></span>Date Latest @if (sortType == '%2DfileCreatedDate' || sortType == '') {
                          <span class="NeueCheck tick"></span>
                        }
                      </li>
                      <li (click)="getSortedFaces('%2BfileCreatedDate','Date Oldest')" class="sort-by-date-oldest">
                        <span class="NeueSort mr-3" title="Sort by oldest date"></span>Date Oldest @if (sortType == '%2BfileCreatedDate') {
                        <span class="NeueCheck tick" ></span>
                      }
                    </li>
                      <li (click)="getSortedFaces('%2BfaceCount','Least Faces')" class="sort-by-least-faces">
                        <span class="NeueSort mr-3" title="Sort by least faces"></span>Least Faces @if (sortType == '%2BfaceCount') {
                        <span class="NeueCheck tick"></span>
                      }
                      </li>
                      <li (click)="getSortedFaces('%2DfaceCount','Most Faces')" class="sort-by-most-faces">
                        <span class="NeueSort mr-3" title="Sort by most faces"></span>Most Faces @if (sortType == '%2DfaceCount') {
                        <span class="NeueCheck tick"></span>
                      }
                      </li>
              </div>
            }
            @if ((universalService.currentAlbum == undefined || universalService.currentAlbum.filesCount != 0) && !universalService.isUserOnSharedLinkByMe) {
              <li (click)="this.selectAllMobile()"><span class="Neueselect-all"></span>Select All</li>
            }
            @if (((universalService.currentAlbum == undefined || universalService.currentAlbum.filesCount != 0) && !universalService.isUserOnSharedLinkByMe)) {
              <li (click)="this.switchOnMobileSelectionMode()"><span class="NeueCheck"></span>Select</li>
            }
            @if (universalService.selectedTab == 'Album Details') {
              <li (click)="decideAction('albumInfo')"><span class="NeueFiles_Info" style="color: var(--pri-color);"></span>Album Info</li>
            }

          }
            @if(this.router.url.includes('/contacts')){
              <li (click)="decideAction('deleteAllcontacts')"><span class="NeueRemove" style="color: var(--pri-color);"></span>Delete All</li>
            }
          </ul>
        </div>
      }
      @if (universalService.uploadButtonClicked) {
        <div class="more-options-menu">
          @if (universalService.selectedTab != 'Albums' && universalService.selectedTab != 'Album Details') {
            <ul>
              <li (click)="uploadButtonClicked()"><span class="NeueFile_Uploading-Stroke"></span>Upload Files</li>
              <li (click)="newFolderClicked()"><span class="NeueAddFolder"></span>New Folder</li>
            </ul>
          }
          @if (universalService.selectedTab == 'Albums') {
            <ul>
              <li (click)="newAlbumClicked()"><span class="NeueAlbums-Stroke"></span>Create an Album</li>
            </ul>
          }
          @if (universalService.selectedTab == 'Album Details') {
            <ul>
              <li (click)="uploadButtonClicked()"><span class="NeueFile_Uploading-Stroke"></span>Upload Files</li>
            </ul>
          }
        </div>
      }
      @if (universalService.isMobileShareOptionClicked) {
        <div class="more-options-menu">
          <div class="modal-header pl-0 pb-0">Share</div>
          <ul>
            <!-- <li (click)="getShareLink()"><span class="NeueLink" style="font-size: 15px;"></span>Share link</li> -->
            @if (!router.url.includes('sharedwithme')) {
              <li (click)="enhancedShareLink()" [ngClass]="this.universalService.isAllowPublicShare == false ? 'hideOption' : ''"><span class="NeueLink" style="font-size: 15px;"></span>Share link</li>
            }
            @if (!(universalService.selectedNodes.length > 1) && !router.url.includes('digilocker') && !router.url.includes('jpai')) {
              <li (click)="shareWithPeopleOption()"><span class="NeueInviteUser"></span>Private share</li>
            }
          </ul>
        </div>
      }
      @if (universalService.moreOptionsOnMobileClicked) {
        <div class="more-options-menu">
          <ul>
            @for (item of universalService.moreOptionsSubMenu; track item) {
              <li (click)="decideAction(item.onClick)">
                @if (item.iconName != '') {
                  <span class="{{item.iconName}}"></span>
                }
                @if (item.imageUrl  && item.iconName == '') {
                  <img class="img-fluid mr-2" src="{{item.imageUrl}}">
                  }{{item.menuItem}}
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  </div>
</div>
}

<!-- SHARE PAGE TOP MENU STARTS -->
@if (universalService.activeRepo =='share' && universalService.isMobileDevice || universalService.activeRepo =='invite' && universalService.isMobileDevice) {
  <div>
    @if (universalService.selectedNodes.length>0) {
      <div>
        <!-- MODAL-2 : More Options on Thumbnails - Mobile -->
        <!-- single file menu options -->
        <div class="modal fade" id="more-options-thumbnails-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': this.universalService.showMobOptionMenu ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
          <div class="modal-dialog" role="document">
            <div class="modal-content animated fixed-bottom">
              <div class="modal-header">
                <div class="mini-thumb-details">
                  <span class="float-left">
                    @if (this.universalService.selectedFile?.objectType != 'FR' && this.universalService.selectedFile?.imageTranscodeUrl != null && this.universalService.selectedFile?.imageTranscodeUrl != undefined) {
                      <div class="imgThumbnailCont"
                        >
                        <img alt="" src="{{this.universalService.selectedFile.imageTranscodeUrl}}"
                          class='img-fluid top-rounded'
                          (error)="this.universalService.thumbnailError($event)" />
                      </div>
                    }
                    @if (universalService.selectedFile?.format == 'Document' || universalService.selectedFile?.format == 'SpreadSheet' || universalService.selectedFile?.format == 'Presentation' || universalService.selectedFile?.format == 'MSOfficeDocument' ) {
                      <div class="imgThumbnailCont"
                        >
                        <img alt="" src="{{universalService.selectedFile.MSOfficeImage}}"
                          class='img-fluid rounded-0'/>
                      </div>
                    }
                    @if (universalService.selectedFile?.format != 'Document' && universalService.selectedFile?.format != 'SpreadSheet' && universalService.selectedFile?.format != 'Presentation' && universalService.selectedFile?.format != 'MSOfficeDocument') {
                      <div class="defaultIconCont">
                        <div
                          class="default-thumbnail-icon {{universalService.topMenuOptions.defaultContent?.defaultClassName}}">
                          <span class="{{universalService.topMenuOptions.defaultContent?.iconName}}"></span>
                        </div>
                      </div>
                    }
                  </span>
                  @if (this.universalService.selectedFile?.objectType != 'FR' && this.universalService.selectedFile?.objectName != undefined) {
                    <span class="float-left pt-3 pl-2 moreOptionFileName">
                      <span
                      class="fileNamePart">{{this.universalService.selectedFile.objectName.split('.').slice(0, -1).join('.')}}</span>.{{this.universalService.selectedFile.objectName.substring(this.universalService.selectedFile.objectName.lastIndexOf('.')
                      + 1)}}
                    </span>
                  }
                  @if (this.universalService.selectedFile?.objectType == 'FR') {
                    <span class="float-left pt-3 moreOptionFolderName">{{this.universalService.selectedFile.objectName}}</span>
                  }
                  <span class="NeueClose float-right pt-3 pl-2" (click)="decideAction('showLessOptions')"></span>
                  @if(this.universalService.activeRepo != 'invite'){
                    <span class="NeueFiles_Info float-right pt-3 pl-2" (click)="this.universalService.openMobileFileInfo(this.universalService.selectedFile)"></span>
                  }
                </div>
              </div>
              <div class="modal-body pt-0">
                <div class="more-options-menu pl-3">
                  <ul>
                    @for (item of universalService.topMenuOptions; track item) {
                      <li (click)="decideAction(item.onClick)">
                        <span class="{{item.iconName}}"></span>
                        <span>{{item.menuItem}}</span>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      @if (this.universalService.mobileSelectionModeOn && this.universalService.showMobOptionMenu == false && (universalService.activeRepo == 'share' || universalService.activeRepo == 'invite')) {
        <div id="m-collapsed-modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content animated fixed-bottom" [ngStyle]="getModalBottomValue()">
              <div class="modal-header">
                <span class="totalSelected">{{universalService.selectedNodes.length}} Selected</span>
                @for (item of universalService.topMenuOptions; track item) {
                  <div class="collapsedMode">
                    <div class="{{item.isDisabled}}" (click)="decideAction(item.onClick)">
                      <span class="{{item.iconName}}"></span>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
      <!-- Mobile Selection Block for SHARE at Footer Ends -->
    </div>
  }
  @if (universalService.showPreview) {
    <div class="previewOptions">
      <div  id="m-collapsed-modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': !universalService.openMoreOptions && universalService.selectedNodes.length>0 ? 'block' : 'none', 'opacity': 1}">
        <div class="modal-dialog" role="document">
          <div class="modal-content animated fixed-bottom" [ngStyle]="{'background': router.url.includes('/memory') ? '#000' : 'none'}">
            <div class="modal-header">
              @for (item of universalService.topMenuOptions; track item) {
                <div class="collapsedMode"  [ngClass]="{'hideOption': item.menuItem === 'Add to Album' && universalService.showFeaturesForEntUsers === true,'align-center-download': universalService.showPreview && universalService.isMobileDevice && universalService.activeRepo === 'invite'}">
                  <div (click)="decideAction(item.onClick,$event)" class="{{item.isDisabled}}">
                    <span class="{{item.iconName}}"></span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
}

<!-- SHARE PAGE TOP MENU ENDS  -->


<!-- MAIN REPO TOP MENU STARTS -->

@if (universalService.activeRepo == 'main' ) {
  <div class="main-repo-mobile-options">
    <!-- single file menu options -->
    @if (this.universalService.showMobOptionMenu) {
      <div class="modal fade" id="more-options-thumbnails-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': this.universalService.showMobOptionMenu ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
        <div class="modal-dialog" role="document">
          <div class="modal-content animated fixed-bottom">
            <div class="modal-header">
              <div class="mini-thumb-details">
                <span class="float-left">
                  @if (this.universalService.selectedFile?.objectType != 'FR' && this.universalService.selectedFile.imageTranscodeUrl != null && this.universalService.selectedFile.imageTranscodeUrl != undefined && this.universalService.selectedFile?.objectType != 'BR') {
                    <div class="imgThumbnailCont"
                      >
                      <img alt="" src="{{this.universalService.selectedFile.imageTranscodeUrl}}"
                        class='img-fluid top-rounded'
                        (error)="this.universalService.thumbnailError($event)" />
                    </div>
                  }
                  @if (universalService.selectedFile?.format == 'Document' || universalService.selectedFile?.format == 'SpreadSheet' || universalService.selectedFile?.format == 'Presentation' || universalService.selectedFile?.format == 'MSOfficeDocument') {
                    <div class="imgThumbnailCont"
                      >
                      <img alt="" src="{{universalService.selectedFile.MSOfficeImage}}"
                        class='img-fluid rounded-0'/>
                    </div>
                  }
                  @if (universalService.selectedFile?.isBackeupItem || (universalService.selectedFile?.format != 'Document' && universalService.selectedFile?.format != 'SpreadSheet' && universalService.selectedFile?.format != 'Presentation' && universalService.selectedFile?.format != 'MSOfficeDocument')) {
                    <div class="defaultIconCont">
                      <div
                        class="default-thumbnail-icon {{universalService.topMenuOptions.defaultContent?.defaultClassName}}">
                        <span class="{{universalService.topMenuOptions.defaultContent?.iconName}}"></span>
                      </div>
                    </div>
                  }
                  @if (universalService.selectedFile?.isBackupDevices) {
                    <div class="defaultIconCont">
                      <div
                        class="default-thumbnail-icon {{universalService.topMenuOptions.defaultContent?.defaultClassName}}">
                        <span class="{{universalService.topMenuOptions.defaultContent?.iconName}}"></span>
                      </div>
                    </div>
                  }
                </span>
                @if (this.universalService.selectedFile?.objectType != 'FR' && this.universalService.selectedFile.objectName != undefined && this.universalService.selectedFile?.objectType != 'BR') {
                  <span class="float-left pt-3 pl-2 moreOptionFileName">
                    @if (universalService.isUserOnSharedLinkByMe) {
                      <span>{{this.universalService.selectedFile.objectName}}</span>
                    }
                    @if (!universalService.isUserOnSharedLinkByMe) {
                      <span><span class="fileNamePart">{{this.universalService.selectedFile.objectName.split('.').slice(0, -1).join('.')}}</span>.{{this.universalService.selectedFile.objectName.substring(this.universalService.selectedFile.objectName.lastIndexOf('.')
                      + 1)}}
                    </span>
                  }
                </span>
              }
              @if (this.universalService.selectedFile?.objectType == 'FR' || this.universalService.selectedFile?.objectType == 'BR') {
                <span class="float-left pt-3 moreOptionFolderName">{{this.universalService.selectedFile.objectName}}</span>
              }
              <span class="NeueClose float-right pt-3 pl-2" (click)="decideAction('showLessOptions')"></span>
              @if (router.url != '/teamfolders' && !router.url.includes('trash') && !universalService.isUserOnSharedLinkByMe && !router.url.includes("digilocker")) {
                <span class="NeueFiles_Info float-right pt-3 pr-2" (click)="this.universalService.openMobileFileInfo(this.universalService.selectedFile)"></span>
              }
            </div>
          </div>
          <div class="modal-body pt-3" [ngClass]="[this.universalService.selectedFile.isBackupDevices == 'Y' ? 'hide' : '']">
            @if (universalService.middleMenuOptionsMobile.length>0) {
              <div class="middle-menu-options ml-2">
                @for (item of universalService.middleMenuOptionsMobile; track item) {
                  <div class="{{item.isDisabled}} pt-2 pb-2" (click)="decideAction(item.onClick)">
                    <span class="{{item.iconName}} mr-2"></span>{{item.menuItem}}
                    <span class="{{item.optionalIconName}} float-right"></span>
                  </div>
                }
              </div>
            }
            <div class="bottom-menu-options pl-3">
              <!-- <div  *ngFor="let items of "> -->
              @for (item of universalService.bottomMenuOptionsMobile; track item) {
                <div class="row" class="{{item.isDisabled}} p-2 col-12" [ngClass]="item.menuItem == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''" (click)="decideAction(item.onClick,$event)" title="{{item.title}}">
                  @if (item.iconName != '') {
                    <span class="{{item.iconName}} mt-1 mr-2"></span>
                  }
                  @if (item.imageUrl  && item.iconName == '') {
                    <img class="img-fluid mr-2" src="{{item.imageUrl}}">
                    }{{item.menuItem}}
                  </div>
                }
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <!-- single file menu options ends -->
  <!-- selection mode on starts -->
  @if (universalService.mobileSelectionModeOn) {
    <div>
      <!-- collapsed mode On starts -->
      <div id="m-collapsed-modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': !universalService.openMoreOptions && universalService.selectedNodes.length>0 ? 'block' : 'none', 'opacity': 1}">
        <div class="modal-dialog" role="document">
          <div class="modal-content animated fixed-bottom" [ngStyle]="getModalBottomValue()">
            <div class="modal-header">
              <span class="totalSelected">{{universalService.selectedNodes.length}} Selected </span>
              @for (item of universalService.topMenuOptions; track item) {
                <div class="collapsedMode" [ngClass]="item.menuItem == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''">
                  <div class="{{item.isDisabled}}" (click)="decideAction(item.onClick)">
                    <span class="{{item.iconName}}"></span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <!-- collapsed mode On ends -->
      <!-- expanded mode on starts -->
      <div class="modal fade" id="m-expanded-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': universalService.openMoreOptions ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
        <div class="modal-dialog" role="document">
          <div class="modal-content animated bounceUp fixed-bottom">
            <div class="modal-header pt-4 pr-4 pb-3 pl-4">
              <span class="totalSelected">{{universalService.selectedNodes.length}} Selected</span>
              @for (item of universalService.topMenuOptions; track item) {
                <span>
                  <span class="{{item.iconName}}"
                  (click)="decideAction(item.onClick,$event)"></span>
                </span>
              }
            </div>
            <div class="modal-body pl-4 pt-2 pb-0 pr-4">
              @if (universalService.middleMenuOptionsMobile.length>0) {
                <div class="middle-menu-options">
                  @for (item of universalService.middleMenuOptionsMobile; track item) {
                    <div class="{{item.isDisabled}} pt-2 pb-3" (click)="decideAction(item.onClick,$event)">
                      <span class="{{item.iconName}} mr-2"></span>{{item.menuItem}}
                      <span class="{{item.optionalIconName}} float-right"></span>
                    </div>
                  }
                </div>
              }
              <div class="bottom-menu-options pl-0">
                <!-- <div  *ngFor="let items of "> -->
                @for (item of universalService.bottomMenuOptionsMobile; track item) {
                  <div class="row mr-0 ml-0" class="{{item.isDisabled}} pb-3 col-12 pl-0" [ngClass]="item.menuItem == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true  || item.menuItem == 'Share' && this.universalService.isAllowPublicShare == false ? 'hideOption' : ''" (click)="decideAction(item.onClick,$event)" title="{{item.title}}">
                    @if (item.iconName != '') {
                      <span class="{{item.iconName}} mt-1 mr-2"></span>
                    }
                    @if (item.imageUrl  && item.iconName == '') {
                      <img class="img-fluid mr-2" src="{{item.imageUrl}}">
                      }{{item.menuItem}}
                    </div>
                  }
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- expanded mode on ends -->
    </div>
  }
  <!-- selection mode on ends -->
  <!-- preview menu starts -->
  @if (universalService.isMobileDevice && ((universalService.showPreview && ((universalService.currentAlbum == undefined || universalService.currentAlbum?.boardType != 'E') &&  (this.universalService.selectedFile?.mimeType == 'audio' || this.universalService.selectedFile?.mimeType == 'video' || this.universalService.selectedFile?.mimeType == 'image'))) || router.url.includes('/memory'))) {
    <div class="previewOptions">
      <div id="m-collapsed-modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': !universalService.openMoreOptions && universalService.selectedNodes.length>0 ? 'block' : 'none', 'opacity': 1}" [ngClass]="router.url.includes('/memory') ? 'memory-collapsed-modal' : ''">
        <div class="modal-dialog" role="document">
          <div class="modal-content animated fixed-bottom" [ngStyle]="{'background': router.url.includes('/memory') ? '#000' : 'none'}">
            <div class="modal-header">
              @for (item of universalService.topMenuOptions; track item) {
                <div class="collapsedMode"  [ngClass]="item.menuItem == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''">
                  <div (click)="decideAction(item.onClick,$event)" class="{{item.isDisabled}}">
                    <span class="{{item.iconName}}"></span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="more-options-thumbnails-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': universalService.openMoreOptions ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
        <div class="modal-dialog" role="document">
          <div class="modal-content animated fixed-bottom">
            <div class="modal-header">
              <div class="mini-thumb-details">
                <span class="float-left">
                  @if (this.universalService.selectedFile?.objectType != 'FR' && this.universalService.selectedFile?.imageTranscodeUrl != null && this.universalService.selectedFile?.imageTranscodeUrl != undefined) {
                    <div class="imgThumbnailCont"
                      >
                      <img alt="" src="{{this.universalService.selectedFile.imageTranscodeUrl}}"
                        class='img-fluid top-rounded'
                        (error)="this.universalService.thumbnailError($event)" />
                    </div>
                  }
                  @if (universalService.selectedFile?.format == 'Document' || universalService.selectedFile?.format == 'SpreadSheet' || universalService.selectedFile?.format == 'Presentation' || universalService.selectedFile?.format == 'MSOfficeDocument') {
                    <div class="imgThumbnailCont"
                      >
                      <img alt="" src="{{universalService.selectedFile.MSOfficeImage}}"
                        class='img-fluid rounded-0'/>
                    </div>
                  }
                  @if (universalService.selectedFile?.format != 'Document' && universalService.selectedFile?.format != 'SpreadSheet' && universalService.selectedFile?.format != 'Presentation' && universalService.selectedFile?.format != 'MSOfficeDocument') {
                    <div class="defaultIconCont">
                      <div
                        class="default-thumbnail-icon {{universalService.topMenuOptions.defaultContent?.defaultClassName}}">
                        <span class="{{universalService.topMenuOptions.defaultContent?.iconName}}"></span>
                      </div>
                    </div>
                  }
                </span>
                @if (this.universalService.selectedFile?.objectType != 'FR' && this.universalService.selectedFile?.objectName != undefined) {
                  <span class="float-left pt-3 pl-2 moreOptionFileName">
                    <span
                    class="fileNamePart">{{this.universalService.selectedFile.objectName.split('.').slice(0, -1).join('.')}}</span>.{{this.universalService.selectedFile.objectName.substring(this.universalService.selectedFile.objectName.lastIndexOf('.')
                    + 1)}}
                  </span>
                }
                @if (this.universalService.selectedFile?.objectType == 'FR') {
                  <span class="float-left pt-3 moreOptionFolderName">{{this.universalService.selectedFile.objectName}}</span>
                }
                <span class="NeueExpand float-right pt-3 pl-2" (click)="decideAction('showLessOptions')"></span>
                @if (!router.url.includes('/trash') && !router.url.includes('/memory')) {
                  <span class="NeueFiles_Info float-right pt-3 pr-2" (click)="this.universalService.openMobileFileInfo(this.universalService.selectedFile)"></span>
                }
              </div>
            </div>
            <div class="modal-body pt-3">
              @if (universalService.middleMenuOptionsMobile.length>0) {
                <div class="middle-menu-options ml-2">
                  @for (item of universalService.middleMenuOptionsMobile; track item) {
                    <div class="{{item.isDisabled}} pt-2 pb-3" (click)="decideAction(item.onClick)">
                      <span class="{{item.iconName}} mr-2"></span>{{item.menuItem}}
                      <span class="{{item.optionalIconName}} float-right"></span>
                    </div>
                  }
                </div>
              }
              <div class="bottom-menu-options pl-0">
                <!-- <div *ngFor="let items of "> -->
                @for (item of universalService.bottomMenuOptionsMobile; track item) {
                  <div class="row" class="{{(item.iconName == 'NeueRemove' && universalService.hideDeleteForPublicPreviewShare) ? 'disabled' : item.isDisabled}} p-2 pl-4 col-12" [ngClass]="item.menuItem == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''" (click)="decideAction(item.onClick,$event)"  title="{{item.title}}">
                    @if (item.iconName != '') {
                      <span class="{{item.iconName}} mt-1 mr-2"></span>
                    }
                    @if (item.imageUrl  && item.iconName == '') {
                      <img class="img-fluid mr-2" src="{{item.imageUrl}}">
                      }{{item.menuItem}}
                    </div>
                  }
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <!-- preview menu ends -->
</div>
}

<!-- MAIN REPO TOP MENU ENDS -->